<template>
	<Page class="black-friday-home" :class="theme">
		<template v-slot:content>
			<SafeAreaTop @close="onClose" closePosition="left" :theme="closeTheme">
				<BlackFridayLogo :theme="theme" />
			</SafeAreaTop>

			<BlackFridaySteps :theme="theme" class="black-friday-home__content container" />
		</template>

		<template v-slot:footer>
			<div class="container">
				<Button @click="goNext" class="btn black-friday-btn">Continue</Button>
			</div>
		</template>
	</Page>
</template>

<script>
import { inject, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import useApi from '@/composition/api.js'
import useConfig from '@/composition/config.js'

import Page from '@/components/Page'
import SafeAreaTop from '@/components/SafeAreaTop'
import Button from '@/components/Button.vue'
import BlackFridayLogo from '@/components/black-friday/Logo.vue'
import BlackFridaySteps from '@/components/black-friday/Steps.vue'
import { useStore } from 'vuex'

export default {
	components: {
		Page,
		SafeAreaTop,
		Button,
		BlackFridayLogo,
		BlackFridaySteps
	},

	setup() {
		const amplitude = inject('amplitude')
		const router = useRouter()
		const api = useApi()
		const config = useConfig()
		const store = useStore()

		const theme = computed(() => config.get({ key: 'paywall.theme', default_value: 'light' }))
		const closeTheme = computed(() => config.get({ key: 'paywall.close_button.theme', default_value: 'dark' }))

		onMounted(() => 
			setTimeout(() => amplitude.logEvent(store.getters['getAmplitudeEventName']('PrePaywallShow'), {
				data_source: 'client',
				offer: 'BlackFriday'
			}), 3000)
		)
		
		const onClose = () => {
			amplitude.logEvent(store.getters['getAmplitudeEventName']('PrePaywallDone'), {
				data_source: 'client',
				action: 'close',
				offer: 'BlackFriday'
			}) 
			api.close()
		}

		const goNext = () => {
			amplitude.logEvent(store.getters['getAmplitudeEventName']('PrePaywallDone'), {
				data_source: 'client',
				action: 'continue',
				offer: 'BlackFriday'
			}) 
			router.push({ name: 'black-friday-paywall'})
		}

		return {
			onClose,
			goNext,
			theme,
			closeTheme
		}
	}
}
</script>

<style lang="scss" scoped>
.black-friday-home {
	&.light {
		--bg-color: #F5F6F8;
	}

	&.dark {
		--bg-color: #1C1E2C;
	}
	background-color: var(--bg-color);

	&__content {
		padding: 24px;
	}

	:deep(.page-footer) {
		background: var(--bg-color);
		padding: 24px;
	}
}

.black-friday-btn {
	background: linear-gradient(266.94deg, #FF4F79 -9.75%, #9671FF 74.67%, #7D8BF7 104.63%), linear-gradient(270deg, #FF4F79 -8.75%, #9671FF 72.59%, #7D8BF7 101.46%);
	border-radius: 100px;
	color: #fff;
	width: 100%;
	border: none;
	letter-spacing: -0.02rem;
}
</style>
